<template>
  <div class="spinner">
    <div class="spinner-wrapper" :class="variantClassName">
      <div class="spinner-dot-1"></div>
      <div class="spinner-dot-2"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      required: false,
    },
  },
  computed: {
    variantClassName() {
      return {
        'spinner-light': this.variant === 'light',
      };
    },
  },
};
</script>
